module.exports = __webpack_public_path__ + "media/shared/assets/fonts/PlusJakartaSans/PlusJakartaSans-Italic-d0760871ba6c8abd90fe89855c03f10e.woff2";